import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["to", "href", "type", "tagName", "refCallback", "innerRef", "activeClassName", "className"];
/* eslint-disable react/prop-types */
import * as React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router';
import { useText } from '../Text';
import { useBox } from '../Box';
import { useFlex } from '../Flex';
/**
 * Helper component.
 * Returns the proper interactive (clickable) element depending on props.
 */
function Interactive(_ref) {
  var to = _ref.to,
    href = _ref.href,
    type = _ref.type,
    tagName = _ref.tagName,
    refCallback = _ref.refCallback,
    innerRef = _ref.innerRef,
    activeClassName = _ref.activeClassName,
    mergeClass = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var _useBox = useBox(extraProps),
    _useBox2 = _slicedToArray(_useBox, 2),
    boxClasses = _useBox2[0],
    boxExtra = _useBox2[1];
  var _useFlex = useFlex(boxExtra),
    _useFlex2 = _slicedToArray(_useFlex, 2),
    flexClasses = _useFlex2[0],
    flexExtra = _useFlex2[1];
  var _useText = useText(flexExtra),
    _useText2 = _slicedToArray(_useText, 2),
    textClasses = _useText2[0],
    textExtra = _useText2[1];
  var className = clsx(boxClasses, flexClasses, textClasses, mergeClass);
  if ((to || href) && extraProps.disabled) {
    if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn("Passing a `disabled` attribute to an anchor element won't have any effect.");
    }
  }
  if (tagName) {
    // $FlowFixMe[cannot-spread-inexact]
    return /*#__PURE__*/React.createElement(tagName, _objectSpread({
      type: type,
      href: href,
      ref: innerRef || refCallback,
      className: className
    }, textExtra));
  }
  if (to) {
    // $FlowFixMe[cannot-spread-inexact]
    return /*#__PURE__*/React.createElement(Link, _objectSpread({
      to: to,
      activeClassName: activeClassName,
      innerRef: innerRef,
      className: className
    }, textExtra));
  }
  if (href) {
    // $FlowFixMe[cannot-spread-inexact]
    return /*#__PURE__*/React.createElement('a', _objectSpread({
      href: href,
      ref: innerRef || refCallback,
      className: className
    }, textExtra));
  }

  // $FlowFixMe[cannot-spread-inexact]
  return /*#__PURE__*/React.createElement('button', _objectSpread({
    type: type,
    ref: innerRef || refCallback,
    className: className
  }, textExtra));
}
export default Interactive;